export default __webpack_public_path__ + "static/media/system-ai.043d04e6.svg";